module.exports = __webpack_public_path__ + "img/kym-ellis-aF1NPSnDQLw-unsplash1.327d5170.png";